import { Link } from '@tanstack/react-router';
import classNames from 'classnames';
import { Fragment } from 'react/jsx-runtime';

export interface Breadcrumb {
  label: string | undefined;
  path?: string;
}

interface Props {
  items: Breadcrumb[];
  center?: boolean;
}

const Breadcrumbs = ({ items, center }: Props) => (
  <nav aria-label="Breadcrumb navigation">
    <ul
      className={classNames(
        'flex flex-wrap items-center gap-2.5 font-semibold leading-[1.42rem] lg:leading-[1.2] mb-2.5 text-sm',
        {
          'justify-center': center
        }
      )}
    >
      {items.map((item, index) => (
        <Fragment key={index}>
          {!!index && (
            <li className="text-secondary-400 font-normal" aria-hidden="true">
              /
            </li>
          )}
          {item.path ? (
            <li className="hover:underline cursor-pointer">
              <Link
                to={item.path}
                aria-current={index === items.length - 1 ? 'page' : undefined}
              >
                {item.label}
              </Link>
            </li>
          ) : (
            <li className="text-secondary-400" aria-current="page">
              {item.label}
            </li>
          )}
        </Fragment>
      ))}
    </ul>
  </nav>
);

export default Breadcrumbs;
